import { Box, Flex, HStack, Text } from '@chakra-ui/react';

import { ArrowUpRightIcon } from '../../../../components/icons';

interface TwoFactorSetupBannerProps {
  onSetupNow: () => void;
}

export const TWO_FACTOR_SETUP_BANNER_HEIGHT = 44;

export default function TwoFactorSetupBanner({
  onSetupNow,
}: TwoFactorSetupBannerProps) {
  return (
    <Box
      bg="#CC5214"
      px={{ base: 4, md: 6 }}
      h={`${TWO_FACTOR_SETUP_BANNER_HEIGHT}px`}
      w="100%"
      role="status"
    >
      <Flex
        align="center"
        justify="space-between"
        gap={{ base: 3, lg: 6 }}
        h="100%"
        maxW="1728px"
        mx="auto"
      >
        <Text
          fontSize=".875rem"
          fontWeight={500}
          color="white"
          lineHeight="20px"
          letterSpacing="0.2px"
          flexShrink={0}
        >
          Setup Two-Factor Authenticator
        </Text>

        <Text
          fontSize=".875rem"
          fontWeight={500}
          color="white"
          lineHeight="20px"
          letterSpacing="0.2px"
          flex="1"
          display={{ base: 'none', md: 'block' }}
        >
          Adds an extra layer of security to your account to protect you from
          unauthorised transactions.
        </Text>

        <HStack
          as="button"
          type="button"
          spacing={1}
          onClick={onSetupNow}
          flexShrink={0}
          cursor="pointer"
          _hover={{ opacity: 0.9 }}
        >
          <Text
            fontSize=".875rem"
            fontWeight={500}
            color="white"
            lineHeight="20px"
            letterSpacing="0.2px"
          >
            Setup 2FA Now
          </Text>
          <ArrowUpRightIcon />
        </HStack>
      </Flex>
    </Box>
  );
}
